// Shared activity types for clubs and activities
export const ACTIVITY_TYPES = [
  'Athletics',
  'Cooking',
  'Craft',
  'Cricket',
  'Dance',
  'Drama',
  'Football',
  'Gymnastics',
  'Judo',
  'Multi-Sport',
  'Netball',
  'Other',
  'Rugby',
  'School Club',
  'Science',
  'Singing',
  'Singing/Music',
  'Swimming',
  'Tech'
];

// Interest types for child profiles (excludes school-related activities)
export const INTEREST_TYPES = ACTIVITY_TYPES.filter(
  type => type !== 'School Club'
);
